import Vue from 'vue';
import VueRouter from 'vue-router';
import IdentidyVerificationContainer from "../layout/IdentidyVerificationContainer.vue";
import DeviceAgreeEnableContainer from "../layout/DeviceAgreeEnableContainer.vue";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: '/qrcode',
    name: 'qrcode',
    component: IdentidyVerificationContainer,
    meta: {
      isCheckedOpenStatusRequired: false,
    },
  },
  {
    path: '/sms',
    name: 'agreeeEnable',
    component: DeviceAgreeEnableContainer,
    meta: {
      isCheckedOpenStatusRequired: false,
    },
  },
  {
    path: '/',
    redirect: '/qrcode',
    meta: {
      isCheckedOpenStatusRequired: false,
    },
  },
  {
    path: '/provisioning/step1',
    name: 'provisioningStep1',
    component: () => import('../layout/deviceProvision/ProvisioningAgreeContainer.vue'),
    meta: {
      isCheckedOpenStatusRequired: true,
    },
  },
  {
    path: '/provisioning/step2',
    name: 'provisioningStep2',
    component: () => import('../layout/deviceProvision/ProvisioningIdentidyInfoContainer.vue'),
    meta: {
      isCheckedOpenStatusRequired: true,
    },
  },
  {
    path: '/provisioning/step3',
    name: 'provisioningStep3',
    component: () => import('../layout/deviceProvision/ProvisioningVerificationCodeContainer.vue'),
    meta: {
      isCheckedOpenStatusRequired: true,
    },
  },
  {
    path: '/provisioning/step4',
    name: 'provisioningStep4',
    component: () => import('../layout/deviceProvision/ProvisioningResultContainer.vue'),
    meta: {
      isCheckedOpenStatusRequired: true,
    },
  },
  {
    path: '/individual/monitor',
    name: 'individualMonitor',
    component: () => import('../layout/individualInfo/IndividualMonitorMapContainer.vue'),
    meta: {
      isCheckedOpenStatusRequired: true,
    },
  },
  {
    path: '/individual/monitor',
    name: 'individualMonitor',
    component: () => import('../layout/individualInfo/IndividualMonitorMapContainer.vue'),
    meta: {
      isCheckedOpenStatusRequired: true,
    },
  },
  {
    path: '/individual/schedule',
    name: 'individualSchedule',
    component: () => import('../layout/individualInfo/IndividualScheduleListContainer.vue'),
    meta: {
      isCheckedOpenStatusRequired: true,
    },
  },
  {
    path: '/individual/schedule/detail',
    name: 'individualDetail',
    component: () => import('../layout/individualInfo/IndividualScheduleDetailContainer.vue'),
    meta: {
      isCheckedOpenStatusRequired: true,
    },
  },
  {
    path: '/individual/schedule/route',
    name: 'individualRoute',
    component: () => import('../layout/individualInfo/IndividualScheduleRouteContainer.vue'),
    meta: {
      isCheckedOpenStatusRequired: true,
    },
  },
  {
    path: '/individual/drivingReport',
    name: 'individualDrivingReport',
    component: () => import('../layout/individualInfo/IndividualDrivingReportRouteContainer.vue'),
    meta: {
      isCheckedOpenStatusRequired: true,
    },
  },
  {
    path: '/individual/deviceInfo',
    name: 'individualDeviceInfo',
    component: () => import('../layout/individualInfo/IndividualDeviceInfoContainer.vue'),
    meta: {
      isCheckedOpenStatusRequired: true,
    },
  },
  {
    path: '/404',
    name: '404',
    component: () => import('../layout/NotFindPageContainer.vue'),
    meta: {
      isCheckedOpenStatusRequired: false,
      hasHinoRedirect:true // 是否處理hino app重導向
    },
  },
  {
    path: '*',
    redirect: '/404',
  },
];

// const routes = [
//   {
//     path: '/qrcode',
//     component: IdentidyVerificationContainer,
//   },
//   {
//     path: '/',
//     redirect: '/qrcode',
//   },
//   {
//     path: '/provisioning',
//     component: { render: (e) => e("router-view") },
//     children: [
//       {
//         path: 'step1',
//         name: 'step1',
//         component: () => import('../layout/deviceProvision/ProvisioningAgreeContainer.vue'),
//       },
//       {
//         path: 'step2',
//         name: 'step2',
//         component: () => import('../layout/deviceProvision/ProvisioningIdentidyInfoContainer.vue'),
//       },
//       {
//         path: 'step3',
//         name: 'step3',
//         component: () => import('../layout/deviceProvision/ProvisioningVerificationCodeContainer.vue'),
//       },
//       {
//         path: 'step4',
//         name: 'step4',
//         component: () => import('../layout/deviceProvision/ProvisioningResultContainer.vue'),
//         props($route) {
//           let paramsObj = {resultData: {}};
//           if (Object.keys($route.params).length) {
//             paramsObj = {
//               resultData: {
//                 enabledStatus: $route.params.enabledStatus,
//                 fleetCode: $route.params.fleetCode,
//                 opened: $route.params.opened,
//                 openedUser: $route.params.openedUser,
//                 carNo: $route.params.carNo,
//                 openedMobile: $route.params.openedMobile,
//                 enabledCode: $route.params.enabledCode,
//                 openTs: $route.params.openTs,
//                 expiredTs: $route.params.expiredTs,
//               }
//             };
//           }
//           return paramsObj;
//         },
//       },
//     ],
//   },
//   {
//     path: '/individual',
//     component: { render: (e) => e("router-view") },
//     children: [
//       {
//         path: 'monitor',
//         component: () => import('../layout/individualInfo/IndividualMonitorMapContainer.vue'),
//       },
//       {
//         path: 'schedule',
//         component: () => import('../layout/individualInfo/IndividualScheduleListContainer.vue'),
//       },
//       {
//         path: 'schedule/detail/:id',
//         name: 'scheduleDetail',
//         component: () => import('../layout/individualInfo/IndividualScheduleDetailContainer.vue'),
//         props($route) {
//           const paramsObj = {
//             params: {
//               journeyCode: $route.params.scheduleNo,
//               drivingDate: $route.params.drivingDate,
//             }
//           };
//           return paramsObj;
//         },
//       },
//       {
//         path: 'schedule/route',
//         component: () => import('../layout/individualInfo/IndividualScheduleRouteContainer.vue'),
//       },
//       {
//         path: 'deviceInfo',
//         component: () => import('../layout/individualInfo/IndividualDeviceInfoContainer.vue'),
//       },
//     ],
//   },
//   {
//     path: '/404',
//     component: () => import('../layout/NotFindPageContainer.vue'),
//   },
//   {
//     path: '*',
//     redirect: '/404',
//   },
// ]

const router = new VueRouter({
  mode: 'history',
  routes
});

router.beforeEach(async (to, from, next) => {
  localStorage.clear();


  // console.log("跳頁",to.query,from.query)
  let duid = to.query.data || from.query.data

  // 攔截hino app串接，查無車號開通資料
  if (to.meta.hasHinoRedirect){
    // 裝置
    next();
    return;
  }
  // 已開通裝置才會進入此頁面，故此頁面跳過驗證是否開通
  if(to.path === '/sms'){
    next();
    return;
  }
  // 驗證是否開通
  await store.dispatch('identidyOpenStatus/deviceUidAction', duid);
  // let a =  await store.dispatch('identidyOpenStatus/openStatusAction',{deviceUid:duid});

  let a =  await store.dispatch('identidyOpenStatus/openStatusAction',{encodedImei: duid});
  if(a.opened !== 0){
    await store.dispatch('identidyInfo/identidyInfoAction',{
        name: a.openedUser,
        carNo: a.carNo,
        phone: a.openedMobile,
        productName: a.productName,
    });

  }


  // console.log("跳頁後",store.state.identidyOpenStatus.openStatus)
  const openStatus = store.state.identidyOpenStatus.openStatus;
  // 若目標路徑是404、landing page、裝置納管頁面，則直接放行，不參與下方switch判斷
   if (!to.meta.isCheckedOpenStatusRequired) next();
  else {
    switch (openStatus) {
      // sessionStorage的openStatus若為0，且目前的頁面不是開通流程的其中一頁，導到同意書頁面
      case 0:
          // 若目前頁面非開通流程的頁面，一律導到同意書頁面
          if (to.path.indexOf('provisioning') === -1) {
            next(`/provisioning/step1?data=${encodeURIComponent(to.query.data)}`);
          }
          // 若目前頁面在開通流程的頁面中，但不是同意書頁面以及開通資料頁面，且沒有輸入的姓名、車號、手機，導到同意書頁面
          else {
              if (to.path !== '/provisioning/step1' && to.path !== '/provisioning/step2') {
                  if (!store.state.identidyInfo.identidyInfo.name || !store.state.identidyInfo.identidyInfo.carNo || !store.state.identidyInfo.identidyInfo.phone) {
                      next(`/provisioning/step1?data=${encodeURIComponent(to.query.data)}`);
                  }
                  else next();
              }
              else next();
          }
          break;
      // sessionStorage的openStatus若為1，目前的頁面不是開通後個人資訊的其中一頁以及開通結果頁面，導到監控地圖
      case 1:
          if (to.path.indexOf('individual') === -1) {
            if (to.path !== '/provisioning/step4') next(`/individual/monitor?data=${encodeURIComponent(to.query.data)}`);
            else next();
          }
          else next();
          break;
      // sessionStorage的openStatus若為2，目前的頁面不是開通後個人資訊的其中一頁，導到裝置資訊
      case 2:
          if (to.path.indexOf('individual') === -1) next(`/individual/deviceInfo?data=${encodeURIComponent(to.query.data)}`);
          else next();
          break;
      // store的openStatus若為空，導到landing page
        default:
          if (to.path !== '/qrcode') next(`/qrcode?data=${encodeURIComponent(to.query.data)}}`);
          else next();
          break;
    }
  }
})

router.afterEach((to) => {
  if(typeof window !== 'undefined'){
    window.gtag('config', 'G-KQGFC7Q2ZE', {
      'page_path': to.fullPath
    });
  }else{
    console.log("ga4 not found")
  }
});

export default router;
